export enum ClinicProfileVisibility {
  PUBLIC = "PUBLIC",
  REGISTERED_USERS = "REGISTERED_USERS",
  PRIVATE = "PRIVATE",
}
